export default {
  verifiedRefurbishedTagLabel: {
    id: 'product_jp_verified_refurbished_tag_label',
    defaultMessage: 'BM Verified Refurbish',
  },
}
